// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWidgetHostConfigAsyncRequestModel from '../../model/get-widget-host-config-async-request-model';
import GetWidgetHostConfigAsyncRequestDTO from '../dto/get-widget-host-config-async-request-dto';
import dtoSchema from '../schemas/get-widget-host-config-async-request-schema';

export default abstract class GetWidgetHostConfigAsyncRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWidgetHostConfigAsyncRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.isDebug = data.isDebug;
      this.isActive = data.isActive;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  isDebug?: boolean;
  /**
  */
  isActive?: boolean;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetWidgetHostConfigAsyncRequestDTO>): GetWidgetHostConfigAsyncRequestModel;
  static toModel(dto: DeepPartial<GetWidgetHostConfigAsyncRequestDTO> | undefined | null): GetWidgetHostConfigAsyncRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWidgetHostConfigAsyncRequestDTO> | undefined | null): GetWidgetHostConfigAsyncRequestModel | undefined {
    return dto ? new GetWidgetHostConfigAsyncRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWidgetHostConfigAsyncRequestModel> | GetWidgetHostConfigAsyncRequestModel): GetWidgetHostConfigAsyncRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      isDebug: unwrapped.isDebug,
      isActive: unwrapped.isActive,
      searchCriteria: unwrapped.searchCriteria,
    } as GetWidgetHostConfigAsyncRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWidgetHostConfigAsyncRequestModel, can not map to GetWidgetHostConfigAsyncRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
